import _ from 'lodash';
import { connect } from 'react-redux';
import { search, remove, update, rerun } from '../../modules/apAutomation/apIngestion';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = (state) => {
	let apIngestions;
	if (state.lists.apIngestionIds) {
		apIngestions = _.map(state.lists.apIngestionIds, (id) => state.maps.apIngestion[id]);
	}

	return {
		apIngestions,
		authUser: state.auth.authUser,
		userMap: state.maps.user,
		resourceMap: state.maps.resource,
		apIngestionDocumentMap: state.maps.apIngestionDocument,
	};
};
const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			apIngestionSearch: search,
			apIngestionRemove: remove,
			apIngestionUpdate: update,
			apIngestionRerun: rerun,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
